import { render } from "./SetRegisterStationDialog.vue?vue&type=template&id=ea814266&scoped=true"
import script from "./SetRegisterStationDialog.vue?vue&type=script&lang=js"
export * from "./SetRegisterStationDialog.vue?vue&type=script&lang=js"

import "./SetRegisterStationDialog.vue?vue&type=style&index=0&id=ea814266&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea814266"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QInnerLoading,QCardSection,QSelect,QTooltip,QCardActions,QBtn});
